const cardItems = [
  {
    title: '进击的巨人 完结篇',
    tag: '日漫神作',
    desc: '艾伦发动地鸣，帕拉迪岛的命运走向终局，史诗级完结不容错过',
    img: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20style%20anime%20illustration%20with%20massive%20titans%20and%20soldiers%2C%20epic%20scale%2C%20dramatic%20sky%2C%20cinematic%20composition%2C%20warm%20orange%20tones&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '凡人修仙传 年番',
    tag: '国漫经典',
    desc: '韩立从凡人到仙人的逆袭之路，3D国漫巅峰之作，每周更新',
    img: 'https://readdy.ai/api/search-image?query=Chinese%203D%20cultivation%20anime%20illustration%2C%20ancient%20Chinese%20immortal%20in%20flowing%20robes%2C%20misty%20mountain%20landscape%2C%20mystical%20atmosphere%2C%20green%20and%20gold%20tones&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '关于我转生变成史莱姆',
    tag: '异世界',
    desc: '利姆露建立魔国联邦，轻松搞笑的异世界冒险，第三季热播',
    img: 'https://readdy.ai/api/search-image?query=Isekai%20anime%20illustration%20with%20slime%20character%20and%20fantasy%20monsters%2C%20colorful%20and%20playful%20style%2C%20kingdom%20building%20theme%2C%20bright%20and%20cheerful%20colors&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '星辰变 第五季',
    tag: '国漫仙侠',
    desc: '秦羽闯荡神界，鸿蒙宇宙世界观宏大，国产3D动画诚意之作',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20anime%20illustration%20of%20cultivator%20in%20celestial%20realm%2C%20floating%20palaces%2C%20cosmic%20energy%2C%20purple%20and%20gold%20mystical%20lighting&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '我推的孩子 第二季',
    tag: '日漫话题',
    desc: '演艺圈背后的故事，阿库亚的复仇之路，现象级作品续篇',
    img: 'https://readdy.ai/api/search-image?query=Anime%20idol%20entertainment%20industry%20illustration%2C%20stage%20performance%20with%20colorful%20lights%2C%20emotional%20drama%2C%20modern%20Japanese%20setting%2C%20vibrant%20pink%20and%20blue%20tones&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '仙逆 年番',
    tag: '国漫热血',
    desc: '王林逆天改命，以凡人之躯比肩神明，国漫黑马口碑爆棚',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20dark%20and%20gritty%20style%2C%20lone%20warrior%20on%20mountain%20peak%2C%20stormy%20sky%2C%20intense%20dramatic%20lighting%2C%20black%20and%20crimson%20color%20scheme&width=600&height=400&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">精选推荐</h2>
          <p className="mt-3 text-sm text-foreground-600">编辑部精选优质动漫，每一部都值得你花时间追</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <div key={item.title} className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-[10px] font-medium bg-background-50/90 text-primary-500 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}